var map = {
	"./amplify-amazon-button_5.entry.js": [
		"77e1",
		"chunk-d716cffc"
	],
	"./amplify-auth-container.entry.js": [
		"398f",
		"chunk-2d0bad0a"
	],
	"./amplify-auth-fields_9.entry.js": [
		"2689",
		"chunk-0d842fd7"
	],
	"./amplify-authenticator.entry.js": [
		"b836",
		"chunk-1fe6c0ca"
	],
	"./amplify-button_3.entry.js": [
		"efa9",
		"chunk-2d23154f"
	],
	"./amplify-chatbot.entry.js": [
		"9b2c",
		"chunk-201cbdee"
	],
	"./amplify-checkbox.entry.js": [
		"db86",
		"chunk-2d228cf2"
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		"e862",
		"chunk-453ea611"
	],
	"./amplify-container.entry.js": [
		"a72f",
		"chunk-2d208de0"
	],
	"./amplify-federated-buttons_2.entry.js": [
		"644c",
		"chunk-170e6741"
	],
	"./amplify-federated-sign-in.entry.js": [
		"a81f",
		"chunk-35d3c3ea"
	],
	"./amplify-form-field_4.entry.js": [
		"f988",
		"chunk-45fd4cca"
	],
	"./amplify-greetings.entry.js": [
		"57dd",
		"chunk-cef5ac28"
	],
	"./amplify-icon-button.entry.js": [
		"182d",
		"chunk-2d0abfcf"
	],
	"./amplify-icon.entry.js": [
		"b8f5",
		"chunk-e5e547a4"
	],
	"./amplify-link.entry.js": [
		"f482",
		"chunk-2d22c8fe"
	],
	"./amplify-nav_2.entry.js": [
		"23a0",
		"chunk-599fd0de"
	],
	"./amplify-photo-picker.entry.js": [
		"c4f1",
		"chunk-000093b5"
	],
	"./amplify-picker.entry.js": [
		"d040",
		"chunk-0000f301"
	],
	"./amplify-radio-button_3.entry.js": [
		"97a4",
		"chunk-5c70c233"
	],
	"./amplify-s3-album.entry.js": [
		"4e6f",
		"chunk-6d0f05d0"
	],
	"./amplify-s3-image-picker.entry.js": [
		"b90a",
		"chunk-ada2b1de"
	],
	"./amplify-s3-image.entry.js": [
		"76ad",
		"chunk-492dfdba"
	],
	"./amplify-s3-text-picker.entry.js": [
		"5af2",
		"chunk-59d8357e"
	],
	"./amplify-s3-text.entry.js": [
		"dce0",
		"chunk-0ab2022f"
	],
	"./amplify-select-mfa-type.entry.js": [
		"fef4",
		"chunk-6f04962e"
	],
	"./amplify-sign-in-button.entry.js": [
		"7358",
		"chunk-f993edd8"
	],
	"./amplify-tooltip.entry.js": [
		"1faa",
		"chunk-2d0b722b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "521b";
module.exports = webpackAsyncContext;